import React from "react";
import { Item } from "admin/views/QuestionnaireResult";

export const ConfigItem = ({ title, children }) => (
	<Item title={title} value={children} />
);
